import { IconButton } from "@mui/material";
import React, { useRef, useState, useEffect, useCallback } from "react";
import { MdCheck } from "react-icons/md";

function VideoItem({ item, setItem, editing, leftPadding, lang }) {
  const contentTextRef = useRef();
  const optionsWindowRef = useRef();
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const srcRef = useRef();

  useEffect(() => {
    if (showMoreOptions) setTimeout(() => window.addEventListener("click", handleClick), 10);
    else window.removeEventListener("click", handleClick);
  }, [showMoreOptions]);

  useEffect(() => {
    if (item.content[lang.code] && srcRef.current) srcRef.current.setAttribute("src", item.content[lang.code]);
  }, [lang]);

  const handleClick = useCallback((e) => {
    if (!optionsWindowRef.current?.contains(e.target)) setShowMoreOptions(false);
  }, []);

  useEffect(() => {
    if (editing) contentTextRef.current.value = item.content[lang.code];
  }, [editing]);

  function changeSource() {
    let temp = item;
    temp.content[lang.code] = contentTextRef.current.value;
    setItem({ ...temp });
  }

  function toggleAutoplay(e) {
    setItem({
      ...item,
      options: {
        ...item.options,
        autoPlay: e.target.checked,
      },
    });
  }

  function toggleControls(e) {
    setItem({
      ...item,
      options: {
        ...item.options,
        enableControls: e.target.checked,
      },
    });
  }

  function toggleLoop(e) {
    setItem({
      ...item,
      options: {
        ...item.options,
        loop: e.target.checked,
      },
    });
  }

  function toggleMuted(e) {
    setItem({
      ...item,
      options: {
        ...item.options,
        muted: e.target.checked,
      },
    });
  }

  return (
    <div className="FW-content">
      {editing && (
        <div className="FW-content-properties">
          <div style={{ display: "flex", flexGrow: 1 }}>
            <label>
              Source:{" "}
              <input
                ref={contentTextRef}
                type="text"
                onKeyDown={(e) => {
                  if (e.key === "Enter") changeSource();
                }}
              />
            </label>
            <IconButton color="blueButton" size="small" onClick={() => changeSource()}>
              <MdCheck />
            </IconButton>
          </div>
          <div style={{ position: "relative" }}>
            <button
              className="FW-content__more-options-button"
              aria-label="more options"
              onClick={() => setShowMoreOptions(true)}
            >
              <svg viewBox="-1 -1 26 26" fill="#000">
                <circle cx="12" cy="2.611" r="2.611" />
                <circle cx="12" cy="12" r="2.611" />
                <circle cx="12" cy="21.389" r="2.611" />
              </svg>
            </button>
            {showMoreOptions && (
              <div ref={optionsWindowRef} className="FW-content__more-options-container">
                <div>
                  <label>
                    <input type="checkbox" checked={item.options?.autoPlay} onChange={toggleAutoplay} />
                    Autoplay
                  </label>
                  <label>
                    <input type="checkbox" checked={item.options?.enableControls} onChange={toggleControls} />
                    HTML player controls
                  </label>
                  <label>
                    <input type="checkbox" checked={item.options?.loop} onChange={toggleLoop} />
                    Loop
                  </label>
                  <label>
                    <input type="checkbox" checked={item.options?.muted} onChange={toggleMuted} />
                    Muted
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {item?.content[lang.code] ? (
        <div className={`FW-video-wrapper ${editing ? "editing" : ""} ${leftPadding ? "left-padding" : ""}`}>
          <video
            key={item.content[lang.code]}
            autoPlay={item.options?.enableAutoplay}
            controls={item.options?.enableControls}
            loop={item.options?.loop}
            muted={item.options?.muted}
            preload="metadata"
          >
            <source ref={srcRef} src={item.content[lang.code]} type="video/mp4" />
          </video>
        </div>
      ) : (
        <div className="FW-content-missing-notification">[No video]</div>
      )}
    </div>
  );
}

export default VideoItem;
